export default __webpack_public_path__ + "static/media/qr-background.0962e950.png";